<template>
  <div class="reserve-pods">
    <h1
      id="head-title"
      class="page-title text-gradient text-center heading"
      data-aos="fade-right"
      data-aos-easing="ease-in-out-quad"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      Reserve Your Stall
    </h1>
    <div
      class="col-10 offset-1 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2 text-center"
    >
      <h6
        class="about-sub-heading my-5"
        data-aos="fade-up"
        data-aos-once="true"
      >
        Bring your brand, your craft, and your energy to one of Leicester's most
        exciting and inclusive events of the year! The Leicester Caribbean
        Carnival is a celebration of culture, creativity, and community and
        we're inviting vendors of all kinds to be right at the heart of it.
        <br />
        <br />

        Whether you're an independent artisan, a local start-up, a street food
        favourite, or a well-established company, we're committed to making
        stall spaces accessible to everyone from individuals to corporates. If
        you've got something special to offer, there's a place for you here.
        <br />
        <br />

        Spaces are limited and in high demand, book your stall today and be part
        of the vibrant pulse of Leicester Caribbean Carnival!
      </h6>
    </div>
    <div class="d-flex justify-content-center flex-wrap">
      <div
        class="card m-3 p-3 shadow-sm"
        style="width: 20rem; border-radius: 8px"
        @click="openStallsForm"
      >
        <div class="card-body">
          <div class="mb-3">
            <div
              class="bg-blue"
              style="width: 50px; height: 50px; border-radius: 50%"
            ></div>
          </div>
          <h5 class="card-title">Food Stalls</h5>
          <img
            src="../../assets/img/hero1.png"
            alt="Stall 2"
            class="event-image mb-3"
          />
          <p class="card-text">
            Taste the deliciousness at our food stall! From savory to sweet, we
            offer something for every palate. Join us for a culinary adventure
            today!
          </p>
          <p class="card-text font-weight-bold">Price: £900.00</p>
          <b-button
            class="btn-carnival bg-yellow text-blue font-weight-bold mt-2"
            @click.stop="openStallsForm"
          >
            Apply for a Stall
          </b-button>
        </div>
      </div>

      <div
        class="card m-3 p-3 shadow-sm"
        style="width: 20rem; border-radius: 8px"
        @click="openStallsForm"
      >
        <div class="card-body">
          <div class="mb-3">
            <div
              class="bg-yellow"
              style="width: 50px; height: 50px; border-radius: 50%"
            ></div>
          </div>
          <h5 class="card-title">Arts and Crafts</h5>
          <img
            src="../../assets/img/hero7.png"
            alt="Stall 2"
            class="event-image mb-3"
          />
          <p class="card-text">
            Discover unique handmade treasures at our arts and crafts stall!
            Find the perfect statement piece or heartfelt gift and add artisan
            charm to your life.
          </p>
          <p class="card-text font-weight-bold">Price: £250.00</p>
          <b-button
            class="btn-carnival bg-yellow text-blue font-weight-bold mt-2"
            @click.stop="openStallsForm"
          >
            Apply for a Stall
          </b-button>
        </div>
      </div>

      <div
        class="card m-3 p-3 shadow-sm"
        style="width: 20rem; border-radius: 8px"
        @click="openStallsForm"
      >
        <div class="card-body">
          <div class="mb-3">
            <div
              class="bg-pink"
              style="width: 50px; height: 50px; border-radius: 50%"
            ></div>
          </div>
          <h5 class="card-title">Promotional</h5>
          <img
            src="../../assets/img/hero8.png"
            alt="Stall 1"
            class="event-image mb-3"
          />
          <p class="card-text">
            Innovation at our promotional stall! Explore cutting-edge solutions
            to elevate your life and business. Join us to stay ahead of the
            curve and revolutionize your world!
          </p>
          <p class="card-text font-weight-bold">Price: £1,500.00</p>
          <b-button
            class="btn-carnival bg-yellow text-blue font-weight-bold mt-2"
            @click.stop="openStallsForm"
          >
            Apply for a Stall
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reserve',
  methods: {
    openStallsForm() {
      window.open('https://forms.gle/5C5TSbohtb25UWNTA', '_blank');
    },
  },
};
</script>

<style scoped>
.card {
  transition: transform 200ms ease-in-out;
}

.card:hover {
  transform: scale(1.03);
  cursor: pointer;
}

.card-title {
  font-weight: 700;
}
.event-image {
  width: 100%;
  height: 150px;
  border-radius: 5px;
  object-fit: cover;
}
.bg-light {
  background-color: #f8f9fa !important;
}
.font-weight-bold {
  font-weight: bold;
}
.reserve-pods {
  padding-bottom: 7rem;
}
.bg-pink {
  background-color: rgb(255, 109, 133);
}
.heading {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
